import { create } from 'zustand';

interface ManageSignatureModalState {
  isOpen: boolean;
  slug: string;
  visitReportId: number;
  isCustomer: boolean;
  documentType: 'visit' | 'period' | 'digest';
  onManageSignatureModalClose: () => void;
  onManageSignatureModalOpen: (
    slug: string,
    report_pk: number,
    isCustomer: boolean,
    documentType: 'visit' | 'period' | 'digest',
  ) => void;
}

export const useManageSignatureModalStore = create<ManageSignatureModalState>(set => ({
  isOpen: false,
  slug: '',
  visitReportId: 0,
  isCustomer: true,
  documentType: 'visit',
  onManageSignatureModalClose: () =>
    set({ isOpen: false, slug: '', visitReportId: 0, isCustomer: true, documentType: 'visit' }),
  onManageSignatureModalOpen: (
    slug: string,
    visitReportId: number,
    isCustomer: boolean,
    documentType: 'visit' | 'period' | 'digest' = 'visit',
  ) => set({ isOpen: true, slug, visitReportId, isCustomer, documentType }),
}));
